export const VISIT_STP = 'stp';
export const VISIT_VISION = 'vision';
export const VISIT_VALET = 'valet';
export const VISIT_TRANSACT_UPON_ENTRY = 'transact-upon-entry';

export type VisitType =
  typeof VISIT_STP | typeof VISIT_VISION | typeof VISIT_VALET | typeof VISIT_TRANSACT_UPON_ENTRY;
